function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

/* eslint-disable multiline-comment-style */
import { deepFindAndCallFnToken } from "./helpers";
export function createPochtaTheme(_ref) {
  var palette = _ref.palette,
      createColor = _ref.color,
      colors = _ref.colors,
      createPalettes = _ref.palettes,
      font = _ref.font,
      createShadows = _ref.shadows,
      createComplexBreakpoints = _ref.complexBreakpoints,
      simpleBreakpoints = _ref.simpleBreakpoints,
      simpleBreakpointsOrder = _ref.simpleBreakpointsOrder,
      createcomponentsTokens = _ref.componentsTokens,
      zIndex = _ref.zIndex,
      grid = _ref.grid;
  // старая палитра фукциональных цветов
  var color = deepFindAndCallFnToken({
    target: createColor,
    fnArgument: {
      palette: palette
    }
  }); // новая палитра фукциональных цветов

  var palettes = createPalettes ? deepFindAndCallFnToken({
    target: createPalettes,
    fnArgument: {
      colors: colors
    }
  }) : null;
  var shadows = deepFindAndCallFnToken({
    target: createShadows,
    fnArgument: {
      palette: palette,
      color: color,
      palettes: palettes,
      colors: colors
    }
  });
  var STEP = 0.05;
  var breakpointsHelpers = {
    up: function up(breakpoint) {
      return "@media (min-width:".concat(typeof breakpoint === "number" ? breakpoint : simpleBreakpoints[breakpoint], "px)");
    },
    down: function down(breakpoint) {
      return "@media (max-width:".concat(typeof breakpoint === "number" ? breakpoint - STEP : simpleBreakpoints[breakpoint] - STEP, "px)");
    },
    between: function between(startBreakpoint, endBreakpoint) {
      if (startBreakpoint === endBreakpoint && typeof endBreakpoint !== "number") {
        var endIndex = simpleBreakpointsOrder.indexOf(endBreakpoint);

        if (endIndex !== -1 && simpleBreakpointsOrder[endIndex + 1]) {
          endBreakpoint = simpleBreakpointsOrder[endIndex + 1];
        }
      }

      if (endBreakpoint === simpleBreakpointsOrder[simpleBreakpointsOrder.length - 1]) {
        return breakpointsHelpers.up(startBreakpoint);
      }

      return "@media (min-width: ".concat(typeof startBreakpoint === "number" ? startBreakpoint : simpleBreakpoints[startBreakpoint], "px) and (max-width: ").concat(typeof endBreakpoint === "number" ? endBreakpoint - STEP : simpleBreakpoints[endBreakpoint] - STEP, "px)");
    },
    only: function only(breakpoint) {
      return breakpointsHelpers.between(breakpoint, breakpoint);
    }
  };
  var complexBreakpoints = createComplexBreakpoints(breakpointsHelpers);

  function isComplexBreakpoint(breakpoint) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Boolean(complexBreakpoints[breakpoint]);
  }

  function isSimpleBreakpoint(breakpoint) {
    return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      Boolean(simpleBreakpoints[breakpoint]) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      simpleBreakpoints[breakpoint] === 0
    );
  }

  var baseTokens = {
    color: color,
    palette: palette,
    palettes: palettes,
    font: _objectSpread(_objectSpread({}, font), {}, {
      color: font.color({
        color: color,
        palette: palette,
        colors: colors,
        palettes: palettes
      })
    }),
    zIndex: zIndex,
    grid: grid,
    shadows: shadows,
    simpleBreakpoints: simpleBreakpoints,
    complexBreakpoints: complexBreakpoints,
    breakpoints: _objectSpread(_objectSpread({}, simpleBreakpoints), complexBreakpoints),
    // Временное решение, пока не синхронизируем варианты между порталом и нтервебом
    __overrides: undefined
  };
  var componentsTokens = deepFindAndCallFnToken({
    target: createcomponentsTokens,
    fnArgument: baseTokens
  });
  return _objectSpread(_objectSpread({}, baseTokens), {}, {
    simpleBreakpointsOrder: simpleBreakpointsOrder,
    breakpointsHelpers: _objectSpread(_objectSpread({}, breakpointsHelpers), {}, {
      isComplexBreakpoint: isComplexBreakpoint,
      isSimpleBreakpoint: isSimpleBreakpoint
    }),
    componentsTokens: componentsTokens
  });
}